import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { loadSlim } from "tsparticles-slim";
import ParticlesBackground from "@/classes/ParticlesBackground";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let mainColor = getComputedStyle(document.documentElement)
  .getPropertyValue("--main-color")
  .trim();
const refParticles = ref(new ParticlesBackground(mainColor));
const particlesInit = async (engine: never) => {
  await loadSlim(engine);
};
const particlesLoaded = async (container: never) => {
  console.log("Particles container loaded", container);
};
window
  .matchMedia("(prefers-color-scheme: dark)")
  .addEventListener("change", ({ matches }) => {
    console.log("Color change", matches);
  });

return (_ctx: any,_cache: any) => {
  const _component_vue_particles = _resolveComponent("vue-particles")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_vue_particles, {
      id: "tsparticles",
      particlesInit: particlesInit,
      particlesLoaded: particlesLoaded,
      options: refParticles.value
    }, null, 8, ["options"]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})